import React, { Component } from 'react';

import {
  Row,
  Col,
  Input,
  FormGroup,
  FormText
} from 'reactstrap';

import TextInput from '../../../shared/components/TextInput';

class BillingInfoForm extends Component {
  render() {
    const { validationMessages } = this.props;

    return (
      <div className="BillingInfoForm">
        <Row>
          <Col xs={12} className="BillingInfoForm_col">
            <TextInput
              name="name"
              placeholder="Billing name"
              warning={validationMessages['name']}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="BillingInfoForm_col">
            <TextInput
              name="address_line1"
              placeholder="Address line 1"
              warning={validationMessages['address_line1']}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="BillingInfoForm_col">
            <TextInput
              name="address_line2"
              placeholder="Address line 2"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="BillingInfoForm_col">
            <TextInput
              name="address_city"
              placeholder="City"
              warning={validationMessages['address_city']}
            />
          </Col>          
        </Row>
        <Row>
          <Col
            className="BillingInfoForm_col"
            xs={6}
            sm={8}
          >
            <FormGroup>
              <Input
                type="select"
                name="address_state"
                placeholder="State"
              >
                <option value="" disabled selected>State</option>
                <option value="AL">Alabama</option>
                <option value="AK">Alaska</option>
                <option value="AZ">Arizona</option>
                <option value="AR">Arkansas</option>
                <option value="CA">California</option>
                <option value="CO">Colorado</option>
                <option value="CT">Connecticut</option>
                <option value="DE">Delaware</option>
                <option value="DC">District Of Columbia</option>
                <option value="FL">Florida</option>
                <option value="GA">Georgia</option>
                <option value="HI">Hawaii</option>
                <option value="ID">Idaho</option>
                <option value="IL">Illinois</option>
                <option value="IN">Indiana</option>
                <option value="IA">Iowa</option>
                <option value="KS">Kansas</option>
                <option value="KY">Kentucky</option>
                <option value="LA">Louisiana</option>
                <option value="ME">Maine</option>
                <option value="MD">Maryland</option>
                <option value="MA">Massachusetts</option>
                <option value="MI">Michigan</option>
                <option value="MN">Minnesota</option>
                <option value="MS">Mississippi</option>
                <option value="MO">Missouri</option>
                <option value="MT">Montana</option>
                <option value="NE">Nebraska</option>
                <option value="NV">Nevada</option>
                <option value="NH">New Hampshire</option>
                <option value="NJ">New Jersey</option>
                <option value="NM">New Mexico</option>
                <option value="NY">New York</option>
                <option value="NC">North Carolina</option>
                <option value="ND">North Dakota</option>
                <option value="OH">Ohio</option>
                <option value="OK">Oklahoma</option>
                <option value="OR">Oregon</option>
                <option value="PA">Pennsylvania</option>
                <option value="RI">Rhode Island</option>
                <option value="SC">South Carolina</option>
                <option value="SD">South Dakota</option>
                <option value="TN">Tennessee</option>
                <option value="TX">Texas</option>
                <option value="UT">Utah</option>
                <option value="VT">Vermont</option>
                <option value="VA">Virginia</option>
                <option value="WA">Washington</option>
                <option value="WV">West Virginia</option>
                <option value="WI">Wisconsin</option>
                <option value="WY">Wyoming</option>
              </Input>
              {validationMessages['address_state'] && (
                <FormText className='DangerFeedback'>
                  {validationMessages['address_state']}
                </FormText>
              )}
            </FormGroup>
          </Col>
          <Col
            className="BillingInfoForm_col"
            xs={6}
            sm={4}
          >
            <TextInput
              name="address_zip"
              placeholder="ZIP code"
              maxLength={5}
              number
              ignoreLengthFeedback
              warning={validationMessages['address_zip']}
            />
          </Col>          
        </Row>
      </div>
    );
  }
}

export default BillingInfoForm;



// WEBPACK FOOTER //
// ./src/shared/components/BillingInfoForm/BillingInfoForm.js